/* eslint-disable
no-return-await, no-console, no-param-reassign,
no-trailing-spaces, arrow-body-style
*/
import axios from 'axios';
import moment from 'moment';

import helper from '@/_libs/helper';

import order from './_order';
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');

const billing = {
  async outstandings(customerId, page = 1, filterSearch, filterArea, onlyPastDue = false) {
    console.log(customerId);
    return await helper.call('billing.outstanding', {
      success: true,
      data: [],
    // }, async () => await axios(helper.path('customers/history/unpaid')));
    }, async () => {
      const res = await axios(helper.path('billing/outstandings'), {
        params: {
          only_past_due: (onlyPastDue === undefined) ? undefined : onlyPastDue.toString(),
          'page[number]': page,

          customer_id: !customerId ? undefined : customerId,

          order_id: !filterSearch ? undefined : filterSearch,
          unix_id: !filterSearch ? undefined : filterSearch,

          area_id: !filterArea ? undefined : filterArea,
        },
      });

      const TODAY = moment(new Date()).startOf('day');
      res.data.data = res.data.data.map((elm) => {
        // const DUE_DATE = DATE_YESTERDAY;
        const DUE_DATE = elm.due;
        const mapped = {
          ...elm,
          sellDate: elm.created_at,
          dueDate: DUE_DATE,
          daysPastDue: TODAY.diff(moment(DUE_DATE), 'days'),
          combinedId: `${elm.unix_order_id}/${elm.id}`,

          order: elm.order ? order.mapOrder(elm.order) : undefined,
        };
        return mapped;
      });
      return res;
    });
  },

  async paymentHistory(customerId) {
    console.log(customerId);
    return await helper.call('billing.payment', {
      success: true,
      data: [],
    // }, async () => await axios(helper.path('customers/history/unpaid')));
    }, async () => {
      const res = await axios(helper.path('billing/'), {
        params: {
          // from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
          // to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
          // 'page[number]': page,

          customer_id: !customerId ? undefined : customerId,

          // order_id: !filterSearch ? undefined : filterSearch,
          // unix_id: !filterSearch ? undefined : filterSearch,

          // area_id: !filterArea ? undefined : filterArea,
        },
      });

      // const TODAY = moment(new Date()).startOf('day');
      // res.data.data = res.data.data.map((elm) => {
      //   // const DUE_DATE = DATE_YESTERDAY;
      //   const DUE_DATE = elm.due;
      //   const mapped = {
      //     ...elm,
      //     sellDate: elm.created_at,
      //     dueDate: DUE_DATE,
      //     daysPastDue: TODAY.diff(moment(DUE_DATE), 'days'),
      //     combinedId: `${elm.unix_order_id}/${elm.id}`,

      //     order: elm.order ? order.mapOrder(elm.order) : undefined,
      //   };
      //   return mapped;
      // });
      return res;
    });
  },

};

export default billing;
